import { SnackbarApiErrorMessage } from '@ui-framework/index';
import { SCOPES } from '@product-framework/pages/ServiceProvider/scope/constants';

const preProcessResponseData = (claimData, rateCardData) => {
  return {
    claimsStatus: claimData?.claimsStatus === 'ACTIVE',
    reviewAllClaims: claimData?.reviewAllClaims,
    laborMatrix: rateCardData?.laborMatrix
      ? {
          label: rateCardData?.laborMatrix?.name,
          value: rateCardData?.laborMatrix?.id,
        }
      : null,
  };
};

const fetchClaimsSetting = async params => {
  const response = await params?.get(params?.claimApiUrl);
  if (response?.ok) {
    return response?.data;
  }
  params?.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

// fetch rate card data.
const fetchRateCard = async params => {
  const response = await params?.get(params?.rateCardUrl);
  if (response?.ok) {
    return response?.data;
  }
  params?.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

const updateClaimsSettingApi = async (params, data, scope) => {
  let body = {
    claimsStatus: data?.claimsStatus ? 'ACTIVE' : 'INACTIVE',
    reviewAllClaims: data?.reviewAllClaims,
  };
  // If location scope, then we need to send the reviewAllClaims only.
  if (scope === SCOPES.LOCATION) {
    body = {
      reviewAllClaims: data?.reviewAllClaims,
    };
  }
  const response = await params?.put(params?.claimApiUrl, body);
  return response;
};

const updateRateCard = async (params, data, scope) => {
  let body = {
    laborMatrix: data?.laborMatrix?.value
      ? {
          id: data?.laborMatrix?.value,
        }
      : null,
  };
  // If location scope, then we need to send the laborMatrixId instead of the laborMatrix object.
  if (scope === SCOPES.LOCATION) {
    body = {
      laborMatrixId: data?.laborMatrix?.value || null,
    };
  }
  const response = await params?.put(params?.rateCardUrl, body);
  return response;
};

export {
  preProcessResponseData,
  fetchClaimsSetting,
  fetchRateCard,
  updateClaimsSettingApi,
  updateRateCard,
};
